import { render } from "./TwilioAfterHoursGreetingEditor.vue?vue&type=template&id=0a4f53ab"
import script from "./TwilioAfterHoursGreetingEditor.vue?vue&type=script&lang=js"
export * from "./TwilioAfterHoursGreetingEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__